import { Fab } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import {
  AddOnItemName,
  UpgradeDialogSource,
  VaOrganizationProfileStatus,
} from "schemas/dashboard";

const EmailBoost = () => {
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const { discoverTab } = useContext(DiscoverViewContext);
  const { organizationVaProfile } = useContext(OrganizationUserContext);
  const isOpen = discoverTab !== null;

  const handleOpenUpgradeEmail = () => {
    setUpgradeDialogSource(UpgradeDialogSource.email_volume_from_va_dashboard);
    const state: CheckoutState = {
      plan: AddOnItemName.email_volume_yearly,
      source: "Email Volume Promo Dialog",
      pageSource: window.location.pathname,
    };
    setOpenCheckoutDialog(state);
  };

  if (organizationVaProfile?.status === VaOrganizationProfileStatus.later) {
    return <></>;
  }

  return (
    <Fab
      variant="extended"
      color="primary"
      aria-label="add"
      sx={{
        position: "fixed",
        bottom: 0,
        right: isOpen ? 420 : { xs: 10, md: 70 },
        borderRadius: 0,
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
      }}
      onClick={handleOpenUpgradeEmail}
    >
      🚀 Boost limit: + 150 pitches
    </Fab>
  );
};

export default EmailBoost;
